import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporateurbaniarentalservice() {



    const cardData =
    {
        keyword: 'Corporate Urbania Rental Services Pune',
        heading: 'Urbania on rent in pune: Corporate Urbania Rental Services Pune',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Corporate Urbania Rental Services Pune for businesses, corporate teams, and organizations across the city. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for daily office commutes, corporate events, client visits, airport transfers, and outstation business trips from Pune. With professional chauffeurs, flexible one-way, round-trip, and monthly rental options, and convenient doorstep pickup from major business hubs including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and hassle-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for corporate Urbania rental services in Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage and valor."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum showcasing Gandhi’s personal artifacts and photographs. Its sprawling gardens and Italian arches make it a peaceful retreat. It also houses the samadhis of Kasturba Gandhi and Mahadev Desai. Aga Khan Palace is Pune’s symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The trust behind the temple is also known for its charitable work. Devotees find immense peace and blessings here. Dagdusheth Ganpati is the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite being in a busy area, it maintains a tranquil spiritual ambiance. Its ancient carvings are a testament to early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. From traditional ornaments and musical instruments to household antiques and sculptures, it is a treasure trove of heritage. The recreated Mastani Mahal is a major attraction. The museum is Pune’s living archive of art and craftsmanship."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation and transformation. Osho Ashram is Pune’s international retreat for tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature. It is Pune’s serene green sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during monsoon. Street vendors selling roasted corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends and sunsets."
  }
],



"services": [
    {
      "name": "Corporate Urbania Rental Services Pune",
      "description": "Corporate Urbania Rental Services Pune provides professional vehicle rental solutions for companies and offices. With well-maintained AC and Non-AC vehicles, trained chauffeurs, and flexible packages, it ensures reliable and comfortable transportation for corporate clients, employee shuttles, and business trips."
    },
    {
      "name": "Urbania Corporate Bus Hire Pune",
      "description": "Urbania Corporate Bus Hire Pune offers fully equipped buses for corporate travel, employee transport, and group commutes. Spacious seating, air-conditioning, professional chauffeurs, and scheduled services guarantee a safe, punctual, and comfortable travel experience for corporate teams."
    },
    {
      "name": "Urbania for Company Travel Pune",
      "description": "Urbania for Company Travel Pune specializes in providing organized and dependable transportation for corporate offices, client meetings, and business events. With well-maintained vehicles, experienced drivers, and a focus on timeliness, it ensures hassle-free travel for employees and executives."
    },
    {
      "name": "Corporate Employee Transport Urbania Pune",
      "description": "Corporate Employee Transport Urbania Pune delivers safe and efficient daily commute solutions for employees. With comfortable seating, reliable service, and trained chauffeurs, it ensures punctual and stress-free office transportation for teams of all sizes."
    },
    {
      "name": "Urbania for Office Commute Pune",
      "description": "Urbania for Office Commute Pune provides regular transportation for corporate employees, offering air-conditioned and well-maintained vehicles with professional drivers. The service focuses on comfort, safety, and punctuality, making daily office travel convenient and reliable."
    },
    {
      "name": "Urbania AC Corporate Hire Pune",
      "description": "Urbania AC Corporate Hire Pune offers premium air-conditioned vehicles for corporate travel, employee shuttles, and business commutes. Spacious interiors, trained chauffeurs, and reliable service provide a smooth and professional travel experience for all corporate clients."
    },
    {
      "name": "Urbania for Corporate Events Pune",
      "description": "Urbania for Corporate Events Pune provides transportation solutions for meetings, conferences, team outings, and company events. Well-maintained AC and Non-AC vehicles, professional drivers, and organized scheduling ensure a comfortable and punctual travel experience for employees and guests."
    },
    {
      "name": "Monthly Corporate Urbania Rental Pune",
      "description": "Monthly Corporate Urbania Rental Pune delivers long-term vehicle rental solutions for businesses, offering consistent and reliable transport for employee commutes, corporate trips, and office events. Vehicles are maintained to high standards and driven by trained chauffeurs for hassle-free monthly service."
    },
    {
      "name": "Chauffeur Driven Corporate Urbania Pune",
      "description": "Chauffeur Driven Corporate Urbania Pune ensures stress-free travel with verified and experienced drivers. Vehicles are spacious, well-maintained, and suitable for daily office commutes, business meetings, and long-distance corporate travel, allowing passengers to focus on their work while traveling comfortably."
    },
    {
      "name": "Reliable Corporate Urbania Service Pune",
      "description": "Reliable Corporate Urbania Service Pune provides trustworthy corporate transportation, emphasizing punctuality, vehicle quality, and professional chauffeurs. Ideal for employee commutes, office trips, and corporate events, the service ensures a safe, smooth, and dependable travel experience."
    },
    {
      "name": "Affordable Corporate Urbania Pune",
      "description": "Affordable Corporate Urbania Pune offers cost-effective corporate transportation solutions without compromising comfort or reliability. Vehicles are well-maintained, spacious, and driven by trained chauffeurs, making it suitable for small to large companies seeking efficient and economical employee transport."
    },
    {
      "name": "Urbania for IT Parks Pune",
      "description": "Urbania for IT Parks Pune provides specialized employee transport services for IT companies and tech parks. With air-conditioned vehicles, trained chauffeurs, and reliable schedules, it ensures safe, comfortable, and timely daily commutes for IT professionals and corporate teams."
    },
    {
      "name": "Best Corporate Urbania Rental Pune",
      "description": "Best Corporate Urbania Rental Pune delivers top-rated corporate transportation services, known for reliability, professionalism, and vehicle quality. Suitable for daily employee commutes, office events, and corporate travel, it guarantees a smooth, safe, and comfortable ride for all corporate clients."
    },
    {
      "name": "Urbania Business Travel Service Pune",
      "description": "Urbania Business Travel Service Pune provides executive transport solutions for business meetings, client visits, and corporate trips. With professional chauffeurs, air-conditioned vehicles, and timely service, it ensures efficient, comfortable, and professional travel for corporate executives."
    },
    {
      "name": "Professional Corporate Urbania Hire Pune",
      "description": "Professional Corporate Urbania Hire Pune offers dedicated and reliable corporate transportation services for offices, employees, and business events. Vehicles are well-maintained, equipped with air-conditioning, and driven by trained chauffeurs to provide a safe, comfortable, and professional travel experience."
    }
  ],
  "tableData": [
    ["Corporate Urbania Rental Services Pune", "Urbania Corporate Bus Hire Pune"],
    ["Urbania for Company Travel Pune", "Corporate Employee Transport Urbania Pune"],
    ["Urbania for Office Commute Pune", "Urbania AC Corporate Hire Pune"],
    ["Urbania for Corporate Events Pune", "Monthly Corporate Urbania Rental Pune"],
    ["Chauffeur Driven Corporate Urbania Pune", "Reliable Corporate Urbania Service Pune"],
    ["Affordable Corporate Urbania Pune", "Urbania for IT Parks Pune"],
    ["Best Corporate Urbania Rental Pune", "Urbania Business Travel Service Pune"],
    ["Professional Corporate Urbania Hire Pune", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Reliable Corporate Urbania Rental Services Pune",
        "WhyChoosedescription": "Corporate Urbania Rental Services Pune is perfect for businesses and organizations looking for comfortable, spacious, and professional transportation solutions for employees and clients."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Corporate Urbania Rental Services Pune provides well-maintained Force Urbania vehicles with ample seating and luggage space, ensuring smooth and hassle-free corporate travel."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Corporate Urbania Rental Services Pune comes with skilled drivers who are familiar with Pune city routes and highways, ensuring safe, timely, and stress-free corporate travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Corporate Urbania Rental Services Pune for competitive rates with no hidden charges, making corporate travel budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Corporate Urbania Rental Services Pune provides round-the-clock assistance for bookings, inquiries, and last-minute corporate travel needs."
    },
    {
        "WhyChooseheading": "Flexible Corporate Packages",
        "WhyChoosedescription": "Corporate Urbania Rental Services Pune offers flexible packages for employee transport, corporate events, airport transfers, and client visits."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles for Corporate Urbania Rental Services Pune are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable travel experience."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Corporate Urbania Rental Services Pune guarantees on-time pickups and dependable service, ensuring smooth and stress-free corporate transportation."
    }
]
}

const faqData = [
    {
        question: 'Is Corporate Urbania Rental Services Pune suitable for daily corporate travel?',
        answer: 'Yes, Corporate Urbania Rental Services Pune is ideal for daily employee transportation, corporate meetings, events, and client visits within Pune and nearby areas.',
    },
    {
        question: 'How can I book Corporate Urbania Rental Services Pune?',
        answer: 'You can book Corporate Urbania Rental Services Pune via phone, WhatsApp, or online for quick and hassle-free corporate reservations.',
    },
    {
        question: 'Why choose Corporate Urbania Rental Services Pune for corporate groups?',
        answer: 'Corporate Urbania Rental Services Pune provides spacious seating, smooth rides, and professional drivers, making it ideal for corporate employees and client transportation.',
    },
    {
        question: 'Are the drivers experienced with Corporate Urbania Rental Services Pune?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles for corporate travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Corporate Urbania Rental Services Pune?',
        answer: 'Absolutely. Corporate Urbania Rental Services Pune allows flexible pickup and drop-off locations across Pune and nearby areas for corporate convenience.',
    },
    {
        question: 'Is Corporate Urbania Rental Services Pune available 24x7?',
        answer: 'Yes, Corporate Urbania Rental Services Pune operates 24x7 to accommodate corporate travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Corporate Urbania Rental Services Pune?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for corporate travel.',
    },
    {
        question: 'What payment options are available for Corporate Urbania Rental Services Pune?',
        answer: 'Corporate Urbania Rental Services Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free experience for corporate clients.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sameer Patil',
        feedback: 'We used Corporate Urbania Rental Services Pune for our employees’ daily commute. The vehicles were comfortable, punctual, and the service was professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Joshi',
        feedback: 'Corporate Urbania Rental Services Pune provided excellent service for our corporate client visits. Highly recommended for businesses!',
        rating: 5,
    },
];


































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Urbania Rental Services Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/corporate-urbania-rental-pune.jpg",
  "description": "Corporate Urbania Rental Services Pune offers AC and non-AC Urbania buses for corporate travel, office commute, employee transport, and business events. Chauffeur-driven services ensure safe, comfortable, and reliable corporate transportation in Pune for IT parks, offices, and professional events.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/corporate-urbania-rental-services-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Corporate Urbania Rental Services Pune | AC & Luxury Corporate Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Corporate Urbania Rental Services Pune for office commute, employee transport, corporate events, and business travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe and comfortable corporate transportation in Pune."
  />

  <meta
    name="keywords"
    content="Corporate Urbania Rental Services Pune, Urbania Corporate Bus Hire Pune, Urbania for Company Travel Pune, Corporate Employee Transport Urbania Pune, Urbania for Office Commute Pune, Urbania AC Corporate Hire Pune, Urbania for Corporate Events Pune, Monthly Corporate Urbania Rental Pune, Chauffeur Driven Corporate Urbania Pune, Reliable Corporate Urbania Service Pune, Affordable Corporate Urbania Pune, Urbania for IT Parks Pune, Best Corporate Urbania Rental Pune, Urbania Business Travel Service Pune, Professional Corporate Urbania Hire Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/40.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Corporateurbaniarentalservice;